var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.095,
    height: 40.095,
    viewBox: "0 0 40.095 40.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4358",
    "data-name": "Group 4358",
    transform: "translate(-746.296 -6418.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M143.019,0H120.45a8.763,8.763,0,0,0-8.763,8.763V31.332A8.763,8.763,0,0,0,120.45,40.1h22.569a8.763,8.763,0,0,0,8.763-8.763V8.763A8.763,8.763,0,0,0,143.019,0",
    transform: "translate(634.609 6418.634)",
    fill: "#202131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M146.737,19.912s.272-6.541-1.334-8.586c-1.043-1.329-2.928-1.615-5.121-1.685-3.884-.124-8.233-.125-8.578-.125s-4.694,0-8.578.125c-2.192.07-4.078.356-5.121,1.685-1.606,2.045-1.334,8.586-1.334,8.586S116.4,26.453,118,28.5c1.043,1.329,2.929,1.615,5.121,1.685,3.884.124,8.233.125,8.578.125s4.694,0,8.578-.125c2.193-.07,4.078-.356,5.121-1.685,1.606-2.045,1.334-8.586,1.334-8.586",
    transform: "translate(634.609 6418.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M128.734,15.513v8.956l7.823-4.478Z",
    transform: "translate(634.609 6418.634)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.958cad782f43d1fbb19a1fe7717433f7.svg";
export { ForwardRef as ReactComponent };